import { Tooltip, useTheme } from '@mui/material';

import { CheckCircle, Error } from '@mui/icons-material';
import { getStyled } from './styles';

const UserStatusIcon = ({ user }) => {
  const theme = useTheme();
  const classes = getStyled(theme);

  return user.online ? (
    <Tooltip title='Online'>
      <CheckCircle sx={classes.on} />
    </Tooltip>
  ) : (
    <Tooltip title='Offline'>
      <Error sx={classes.off} />
    </Tooltip>
  );
};

export default UserStatusIcon;
